$('.tego-displaychoice').displaychoice();

$('[name="identite[civilite]"],[name="civilite"]').bind('change', function () {
    if ($(this).val() != 'MME') {
        $('[name="identite[nomJeuneFille]"],[name="nomJeuneFille"]').val('');
    }
});

$('[data-displaychoice-parent="clauseBeneficiaire"]')
    .on('visible', function () {
        $(this).find('textarea').attr('required', 'required')
    })
    .on('hidden', function () {
        $(this).find('textarea').removeAttr('required')
    });
